import { render, staticRenderFns } from "./DangerousEditModal.vue?vue&type=template&id=2a8dc1b0&scoped=true&"
import script from "./DangerousEditModal.vue?vue&type=script&lang=js&"
export * from "./DangerousEditModal.vue?vue&type=script&lang=js&"
import style0 from "./DangerousEditModal.vue?vue&type=style&index=0&id=2a8dc1b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8dc1b0",
  null
  
)

export default component.exports